export function isMobileDimensions(): boolean {
  return window.innerWidth <= 700 || window.innerHeight <= 600;
}
